import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  goBackFlag: false,
  statusBarFlag:false,
}

const mutations = {
  inverseFlag(state){
    state.goBackFlag = !state.goBackFlag;
  },
  getStatusBarFlag(state){
    state.statusBarFlag = !state.statusBarFlag;
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions: {
  },
  modules: {
  }
})
